import React from "react";
import { useProductContext } from "../../context/ProductContext";
import Box from "@mui/material/Box";
import Review from "./Review";

const DashboardMyReviewsPerPage = ({ foundReviews }) => {
  const { products } = useProductContext();
  return (
    <div style={{}}>
      {foundReviews?.map((review) => {
        let index = "";

        let productName = "";
        products.map((pro) => {
          if (pro.productId === review.productId) {
            productName = pro.title;
          }
        });

        products.map((product, idx) => {
          if (product.productId === review.productId) {
            index = idx;
          }
        });
        return (
          <Box
            sx={{
              display: "flex",
              borderBottom: "1px solid lightgray",
              py: 2,
              minHeight: "200px",
              marginBottom: "30px",
            }}
          >
            <Box sx={{ pt: 3, minWidth: "100px" }}>
              <img
                src={products[index].img}
                alt=""
                width="100"
                style={{ position: "relative", left: "-20px" }}
              />
            </Box>
            <Review
              id={review.id}
              rating={review.rating}
              name={review.name}
              title={review.title}
              review={review.comment}
              imgs={review.images}
              uid={review.uid}
              link={"dashboard-review"}
              productId={review.productId}
              productName={productName}
            />
          </Box>
        );
      })}
    </div>
  );
};

export default DashboardMyReviewsPerPage;
